import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

type PropsType = {
  title?: string;
  children?: any;
  btnTitle?: string;
};

const UserHeroSection = ({ title, btnTitle, children }: PropsType) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1020);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1020);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);
  return (
    <section id="hero">
      <div className="tw-w-full tw-bg-[#F7F7F7]">
        {/* first Item */}
        <div className="tw-flex tw-relative tw-py-12 tw-bg-[#F7F7F7] tw-items-center tw-justify-between">
          <div className="flex-1 tw-absolute tw-left-[30px] lg:tw-left-[60px]">
            <p className="tw-text-3xl lg:tw-text-[35px] tw-text-black tw-font-bold">{title}</p>
            <div className="sm:tw-text-[12px] tw-text-[8px] tw-text-[red] tw-font-normal tw-mt-2">
              <span className="sm:tw-text-[14px] tw-text-[10px] tw-font-semibold">Note:</span> The turnaround time is 21
              business days from sample receipt for the Essential Test, 10 business days for the Premium Test, and 2–3
              business days for the Premium Priority Test.
            </div>
          </div>

          {btnTitle && (
            <div className="flex-1 tw-absolute  tw-right-[10px] sm:tw-right-[90px]">
              <button
                className="tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-text-[14px] sm:tw-text-[1.125rem] tw-text-black tw-font-medium tw-px-[16px] sm:tw-px-[1.25rem] tw-py-[0.5rem] tw-bg-[#f7f7f7] tw-border-[0.0625rem] tw-border-black"
                onClick={() => {
                  let path = "add";
                  window.location.pathname !== "/user/care-team"
                    ? navigate(`/user/pets/edit-pet-details/${path}`)
                    : navigate(`/user/care-team/add-care-team/${path}`);
                }}
              >
                {btnTitle}
              </button>
            </div>
          )}
        </div>
        {/* second Item */}

        <div className="tw-w-full tw-flex tw-flex-col tw-pt-8 tw-pb-36 tw-rounded-t-3xl tw-shadow-inner tw-relative">
          <div
            className="tw-absolute tw-inset-0 tw-bg-[url('/src/assets/images/section-bg.svg')] tw-bg-center tw-bg-no-repeat tw-bg-cover"
            style={{ mixBlendMode: "luminosity" }}
          ></div>
          {/* Rest of your content */}
          <div className="tw-z-10 tw-flex tw-flex-col tw-gap-8">{children}</div>
        </div>
      </div>
    </section>
  );
};

export default UserHeroSection;
